import styled, { css } from 'styled-components';
import { Search } from '@magalu/stereo-ui-icons';
import { color, getMediaQuery, getPaletteColor, getTextColor, themeGet } from '@magalu/stereo-ui-styles';
import { shadow, grid, space, typography } from 'styled-system';
import Flex from '../../atoms/Flex';
import Box from '../../atoms/Box';
import BaseList from '../../molecules/List';

const variations = ({
  displayMode
}) => {
  const containerStyle = {
    gallery: css`
      grid-template-columns: 1fr 1fr;
      ${getMediaQuery('small')} {
        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
      }
    `,
    list: css`
      grid-template-columns: 1fr;
    `,
    miniature: css`
      grid-template-columns: 1fr 1fr 1fr;
      ${getMediaQuery('small')} {
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      }
    `
  };
  return containerStyle[displayMode];
};

export const NotFound = styled(Flex).attrs(props => Object.assign({
  fontSize: [1, 2, 2, 2],
  py: 3,
  px: 2,
  color: 'text.scratched',
  borderRadius: 'medium',
  bg: 'transparent',
  textAlign: ['center', 'left', 'left', 'left'],
  boxShadow: [4, 'none', 'none', 'none']
}, props))`
  min-width: 280px;
  margin: 0 auto;
  border-radius: 4px;
  transition: width 0.2s ease;
  word-break: break-word;

  ${shadow}
  ${color}
  ${space}
  ${typography}
`;
export const NotFoundTitle = styled.h1.attrs(props => Object.assign({
  fontSize: [3, 5, 5, 5],
  fontWeight: 'regular'
}, props))`
  text-align: center;
  color: ${props => getTextColor('base')(props)};
  line-height: normal;
  margin-bottom: 18px;
  span {
    color: ${props => getPaletteColor('primary.base')(props)};
    display: inline-flex;
    word-wrap: break-word;
    overflow: hidden;
    max-height: 2.4em;
    line-height: 1.2em;
  }

  ${getMediaQuery('small')} {
    text-align: left;
  }

  ${typography}
`;
export const SearchIconWrapper = styled.span.attrs(() => ({
  mr: 3
}))`
  display: none;

  ${getMediaQuery('small')} {
    display: block;
  }

  ${space}
`;
export const SearchIcon = styled(Search).attrs(props => Object.assign({
  width: 60,
  height: 60,
  color: 'primary.base'
}, props))`
  ${color}
`;
export const Container = styled(Box).attrs(props => Object.assign({}, props))`
  margin: 0;
  overflow: hidden;
  transition: width 0.2s ease;
`;
export const List = styled(BaseList).attrs(props => Object.assign({
  gridGap: ['2px', '1px', '1px']
}, props))`
  ${({
  displayMode
}) => variations({
  displayMode
})}
  ${grid}
`;
export const ListAction = styled(List.Action).attrs(() => ({
  fontWeight: 'regular',
  color: 'background.primary',
  fill: 'background.primary'
}))`
  border-top: ${themeGet('borders.0')};
`;
export const ListItem = styled.li`
  list-style: none;
  > * {
    min-height: 100%;
  }
`;